import { render, staticRenderFns } from "./select-team-setting.vue?vue&type=template&id=7b2c2d76&scoped=true&"
import script from "./select-team-setting.vue?vue&type=script&lang=js&"
export * from "./select-team-setting.vue?vue&type=script&lang=js&"
import style0 from "./select-team-setting.vue?vue&type=style&index=0&id=7b2c2d76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2c2d76",
  null
  
)

export default component.exports